import PropTypes from 'prop-types';
import React from 'react';

import SwiperImages from 'components/shared/swiper-images/swiper-images';

const SwiperCarousel = ({ blok }) => {
  const slideImages = blok?.blocks?.map((slide) => ({
    image: slide.image,
    mobileImage: slide.mobile_image,
    title: slide.title,
    text: slide.text,
    link: slide.link,
  }));

  return <SwiperImages images={slideImages} type="carousel" />;
};

export default SwiperCarousel;

SwiperCarousel.propTypes = {
  blok: PropTypes.object.isRequired,
};
